import { AuthenticatedUser } from '../components/common/AuthenticatedComponent';

class UserStore {
    private _user: AuthenticatedUser | null;
    private _impersonatedCountry: any;

    public constructor() {
        this._user = null;
    }

    public fetchUserFromLocalStorage(): AuthenticatedUser | null {
        return this._user;
    }

    public saveUserToLocalStorage(user: AuthenticatedUser) {
        this._user = user;
    }

    public removeUserFromStorage() {
        this._user = null;
    }

    public fetchCountryImpersonationFromSessionStorage(): {
        id: number;
        name: string;
    } {
        return this._impersonatedCountry;
    }

    public saveCountryImpersonationToLocalStorage(country: { id: number; name: string }) {
        this._impersonatedCountry = country;
    }

    public removeCountryImpersonationFromLocalStorage() {
        this._impersonatedCountry = null;
    }
}

export default new UserStore();
